import Typography from "@/ui/atoms/Typography"
import { FieldDefinition } from "../../types"

export type FieldErrorType = "required" | "format"

export interface CustomFieldErrorProps {
  field: FieldDefinition
  error?: FieldErrorType
}

const getFieldErrorMessages = (
  field: FieldDefinition,
  error?: FieldErrorType
) => {
  switch (error) {
    case "required":
      return field.messages?.requiredError
    case "format":
      return field.messages?.formatError
  }
}

const CustomFieldError = ({ error, field }: CustomFieldErrorProps) => {
  if (!error) {
    return <></>
  }
  return (
    <Typography color={"error"}>
      {getFieldErrorMessages(field, error)}
    </Typography>
  )
}

export default CustomFieldError
